export const getQrSigningUrl = (url) => {
    if (!url) return "";

    const hashIndex = url.indexOf("#");

    const baseUrl =
        hashIndex === -1 ? url : url.slice(0, hashIndex);

    const hash =
        hashIndex === -1 ? "" : url.slice(hashIndex);

    // Avoid adding a duplicate parameter if it already exists.
    const cleanUrl = baseUrl.replace(
        /([?&])signingChannel=[^&]*&?/i,
        (match, separator) => {
            if (separator === "?" && match.endsWith("&")) {
                return "?";
            }

            return separator === "?" ? "?" : "";
        }
    );

    const separator = cleanUrl.includes("?")
        ? (cleanUrl.endsWith("?") || cleanUrl.endsWith("&") ? "" : "&")
        : "?";

    return `${cleanUrl}${separator}signingChannel=QR${hash}`;
};



export default getQrSigningUrl;